<script>
  let { size = "md", color = "indigo" } = $props();

  // Compute size classes
  let sizeClass = $state("text-2xl");
  let letterSpacing = $state("tracking-normal");

  $effect(() => {
    switch (size) {
      case "sm":
        sizeClass = "text-lg";
        letterSpacing = "tracking-normal";
        break;
      case "lg":
        sizeClass = "text-4xl";
        letterSpacing = "tracking-tight";
        break;
      default: // md
        sizeClass = "text-2xl";
        letterSpacing = "tracking-normal";
    }
  });

  // Compute color classes
  let colorClass = $state("text-indigo-600");

  $effect(() => {
    switch (color) {
      case "purple":
        colorClass = "text-purple-600";
        break;
      case "gray":
        colorClass = "text-gray-600";
        break;
      default: // indigo
        colorClass = "text-indigo-600";
    }
  });
</script>

<span
  style="font-family: 'Poppins', sans-serif"
  class={`${sizeClass} ${colorClass} ${letterSpacing}`}
>
  SocialsTrack
</span>
